export const insights = [
  {
    slug: 'risk-has-changed',
    type: 'Perspective',
    title: 'Risk has changed. Your protection strategy should too.',
    excerpt:
      'Cyber, climate, supply chain, and geopolitical shocks now arrive together. Insurance alone cannot carry organizational resilience.',
    date: '2026-03-01',
  },
  {
    slug: 'introducing-aera',
    type: 'Framework',
    title: 'Introducing AERA™: Enterprise Resilience by Design',
    excerpt:
      'How ALEgION’s five-layer architecture elevates organizations from transactional protection to engineered resilience.',
    date: '2026-02-15',
  },
  {
    slug: 'beyond-insurance',
    type: 'Whitepaper',
    title: 'Beyond Insurance. Into Resilience.',
    excerpt:
      'A strategic brief for boards and executives on building protection architectures where insurance is one integrated component.',
    date: '2026-01-20',
  },
  {
    slug: 'cyber-as-resilience',
    type: 'Research',
    title: 'Cyber is not an IT problem—it is a resilience problem',
    excerpt:
      'Why cyber exposure must be designed into enterprise continuity, governance, and recovery—not bolted on after the fact.',
    date: '2025-12-10',
  },
  {
    slug: 'resilience-index-preview',
    type: 'Report',
    title: 'Annual Resilience Index — Preview',
    excerpt:
      'Early signals from ALEgION’s Resilience Index on maturity gaps across manufacturing, healthcare, and technology.',
    date: '2025-11-05',
  },
  {
    slug: 'ceo-perspective-resilience',
    type: 'CEO Perspective',
    title: 'Where risk ends and resilience begins',
    excerpt:
      'A leadership reflection on why organizations must engineer resilience—not merely transfer risk.',
    date: '2025-10-18',
  },
];

export const ecosystemNodes = [
  'Prevention',
  'Assessment',
  'Insurance',
  'Technology',
  'Response',
  'Recovery',
  'Governance',
  'Training',
];

export const clients = [
  'BHEL',
  'NALCO',
  'IRDAI',
  'Enterprise Partners',
  'Healthcare Networks',
  'Manufacturing Leaders',
  'Infrastructure Operators',
  'Technology Firms',
];

export const technologyFeatures = [
  { title: 'AI & Prescriptive Intelligence', description: 'Signal detection and foresight to anticipate disruption earlier.' },
  { title: 'Analytics & Dashboards', description: 'Executive visibility into risk, readiness, and resilience performance.' },
  { title: 'Risk Monitoring', description: 'Continuous monitoring across operational and digital risk domains.' },
  {
    title: 'QRify',
    description:
      'Accelerated Emergency Response—QR-enabled intervention that bridges incident to care when every second counts.',
    href: 'https://svasth.ai/product',
  },
  {
    title: 'Svasth.ai',
    description:
      'Early Warning Solution—AI-driven health intelligence, real-time alerts, and coordinated care for workforce resilience.',
    href: 'https://svasth.ai/',
  },
  { title: 'Early Warning Systems', description: 'Alerting and horizon signals that feed AERA™ Anticipate.' },
  { title: 'Digital Assessments', description: 'Structured diagnostics for maturity, exposure, and readiness.' },
  { title: 'Cyber Risk modeling and monitoring', description: 'Live views that support Activate and Advance layers.' },
  {
    title: 'Claims Resilience Framework',
    description:
      'Pre-loss readiness, active claim management, and post-loss resilience—claims engineered as a resilience system.',
    href: '/technology#claims-resilience-framework',
  },
];
